module.exports = __webpack_public_path__ + "img/outlook.54c16634.png";